import { ReturnStatement } from '@angular/compiler';
import { Question } from '../shared/question';
import { Response } from '../shared/response';
import { ApplicationStorage } from './applicationStorage';
//@ts-ignore
import moment from 'moment';

export class SurveyDay14OnboardingG4 {

    age: any;
    segment: any;
    endgame: boolean;
    surveyOutroText: any;
    keepAge: any;

    question1: Question;
    question2: Question;
    question3: Question;
    question4: Question;
    question5: Question;


    questions: Array<Question>;

    constructor(private applicationStorage: ApplicationStorage) {
        // this.surveyConsumerAgreement = false;//TODO
        this.endgame = false;

        //(0.1) 
        this.question1 = new Question(1, [],
            'Cât de mulțumit ești per ansamblu de experiența oferita de noul dispozitivul Ploom AURA si Sobranie sticks?',
            'de la 1 la 10 (1 fiind cel mai mic scor - total nemultumit și 10 fiind cel mai mare - fpoarte multumit)',
            'radio-inline',
            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true);



        //(0.3) 
        this.question2 = new Question(2, [1],  // 1a
            'Cum apreciezi noua experienta Ploom AURA in comparatie cu anterioara (folosind dispozitivul Ploom X Advanced)?',
            'de la 1 la 10 (1 fiind cel mai mic scor - inferior  și 10 fiind cel mai mare - superior)',
            'radio-inline',

            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10')

            ],

            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true);

        this.question2.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question1Responses = this.question1.responses.filter(r => r.selected);
            if (question1Responses.length > 0) {
                this.endgame = false;

                return true;
            } else {
                this.question2.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }


        this.question3 = new Question(3, [2],  // 1a
            'Ce motive te-au determinat sa dai scorul la punctul anterior?  ',
            '',
            'checkbox-free',
            [new Response(0, 'Forma, design-ul dispozitivului'),
            new Response(1, 'Experienta per ansamblu este pe placul meu in ceea ce priveste nivelul de intensitate si/sau profilul de savoare '),
            new Response(2, 'Altele')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
        );

        this.question3.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question2Responses = this.question2.responses.filter(r => r.selected);
            let question3SelectedIds = this.question3.responses.filter(r => r.selected)

            if (question2Responses.length > 0) {
                return true;
            }
            else {
                this.question3.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }





        this.question4 = new Question(4, [3],  // 1a
            'Vei continua sa folosesti noul Ploom AURA?',
            '',
            'radio',
            [new Response(0, 'Da'),
            new Response(1, 'Nu')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
        );

        this.question4.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question3Responses = this.question3.responses.filter(r => r.selected).map(r => r.text);
            if (question3Responses.includes('Altele')) {
                if (this.question3.responses?.[2]?.freeMessage) {
                    return true;
                }
                else { return false; }
            } else if (question3Responses.length > 0) {
                return true;
            } else {
                this.question4.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }



        this.question5 = new Question(5, [4],  // 1a
            'Ai recomanda noul Ploom AURA prietenilor tai adulti, consumatori existenti de produse cu nicotina?',
            '',
            'radio',
            [new Response(0, 'Da'),
            new Response(1, 'Nu')
            ],
            false,
            'horizontal',
            undefined,
            undefined,
            undefined,
            '',
            true,
        );

        this.question5.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question4Responses = this.question4.responses.filter(r => r.selected)
            if (question4Responses.length > 0) {
                return true;
            } else {
                this.question5.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }

        this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5];

        // console.log(this.questions)

    }


    getQuestions(): Array<Question> {
        return this.questions;
    }






}




